import { render, staticRenderFns } from "./CmsContentText.vue?vue&type=template&id=59dd574e&scoped=true"
import script from "./CmsContentText.vue?vue&type=script&lang=js"
export * from "./CmsContentText.vue?vue&type=script&lang=js"
import style0 from "./CmsContentText.vue?vue&type=style&index=0&id=59dd574e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd574e",
  null
  
)

export default component.exports